
















import Widget from "@/components/common/Widget.vue";

import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";
import store from "@/store";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
  },
})
export default class OPOSDebitoren extends Vue {
  public static id = "OPOSDebitoren";
  public static dprops = { width: 4, height: 4, minWidth: 4, minHeight: 4 };
  get _id() {
    return OPOSDebitoren.id;
  }
  get _dprops() {
    return OPOSDebitoren.dprops;
  }
  get planSelected() {
    return store.getters.planSelected;
  }
}
